import React from 'react'
import styled from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import theme from 'theme'
import media, { pixels } from 'media'

import Carousel from '@anvilco-pkg/ui/components/Carousel'
import SimplePostSummary, {
  Container,
} from 'components/summaryCards/SimplePostSummary'
import { mergeMdAndSanityPosts, getBlogPostPaths } from 'lib/content'

const StyledCarousel = styled(Carousel)`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: inherit !important;
    display: flex !important;
    justify-content: center;

    & > div {
      height: inherit !important;
      display: flex !important;
    }

    ${Container} {
      height: inherit;
    }
  }
`

const SummaryContainer = styled(Box).attrs({
  px: [10],
})`
  display: inline-flex !important;
  flex-direction: column;
  height: inherit;

  ${Container} {
    margin: 0 auto;
    max-width: 450px;
    flex: 1;
  }

  ${media.desktop`
    ${Container} {
      max-width: 350px;
    }
  `}

  @media (min-width: ${theme.paperMaxWidth}px) {
    padding-left: 0;
    padding-right: 0;
  }
`

const getPosts = ({ nodes, sanityImageNodes, sanityNodes, orders }) => {
  const posts = mergeMdAndSanityPosts({
    markdown: {
      nodes,
      opts: { indexPage: true, skipValidation: true }, // skipValidation does nothing rn
    },
    sanity: {
      nodes: sanityNodes || [],
      opts: { indexPage: true, skipValidation: true },
    },
    sanityImageNodes,
  })

  const sortedPosts = orders
    ? posts.sort(({ slug: slugA }, { slug: slugB }) => {
        return orders[slugB] - orders[slugA]
      })
    : posts

  return sortedPosts.map((post) => {
    const { title, summary, heroImage, tags } = post

    return {
      title,
      description: summary.plainText,
      image: heroImage,
      to: getBlogPostPaths(post).primaryPath,
      tags,
    }
  })
}

export default function BlogPosts ({ pageId, finance, insurance, realEstate }) {
  const renderBlogPosts = (posts) => {
    // NOTE: react-slick's responsive works by MAX WIDTH,
    // not min-width
    return (
      <StyledCarousel
        slidesToShow={3}
        withArrows
        arrowsPosition="bottom-right"
        responsive={[
          {
            breakpoint: pixels.giant,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: pixels.desktop,
            settings: {
              slidesToShow: 1,
            },
          },
        ]}
      >
        {posts
          .sort((a, b) => {
            if (a.tags.includes('Customer stories')) {
              return -1
            } else {
              return 1
            }
          })
          .map(({ title, description, image, to }) => (
            <SummaryContainer key={title}>
              <SimplePostSummary
                title={title}
                description={description}
                image={image}
                to={to}
              />
            </SummaryContainer>
          ))}
      </StyledCarousel>
    )
  }

  if (pageId === 'insurance') {
    const posts = getPosts({
      nodes: insurance.customerStories,
      sanityImageNodes: insurance.titleImages,
      sanityNodes: insurance.sanityCustomerStories,
    })
    return renderBlogPosts(posts)
  } else if (pageId === 'finance') {
    const posts = getPosts({
      nodes: finance.customerStories,
      sanityImageNodes: finance.titleImages,
      sanityNodes: finance.sanityCustomerStories,
      orders: {
        'first-ascent': 2,
        'catalyst-private-wealth': 4,
        'octave-wealth': 5,
        'sunrise-banks': 1,
        mainstreet: 3,
      },
    })
    return renderBlogPosts(posts)
  } else if (pageId === 'real-estate') {
    const posts = getPosts({
      nodes: realEstate.customerStories,
      sanityImageNodes: realEstate.titleImages,
      sanityNodes: realEstate.sanityCustomerStories,
    })
    return renderBlogPosts(posts)
  } else {
    return null
  }
}
